const columns = [
  {
    name: 'User ID',
    selector: (row) => row?.user_id,
    sortable: true,
    sortField: 'user_id',
  },
  {
    name: 'WMRC Name',
    selector: (row) => row?.wmrc_name,
    sortable: true,
    sortField: 'wmrc_name',
  },
  {
    name: 'Comment Request Count',
    selector: (row) => row?.comment_request_count,
    sortable: true,
    sortField: 'comment_request_count',
  },
];

export { columns };


export const mobileColumns = [
{
  name: 'User ID',
  selector: (row) => row?.user_id,
  sortable: true,
  sortField: 'user_id',
},
{
  name: 'WMRC Name',
  selector: (row) => row?.wmrc_name,
  sortable: true,
  sortField: 'wmrc_name',
},
{
  name: 'Comment Request Count',
  selector: (row) => row?.comment_request_count,
  sortable: true,
  sortField: 'comment_request_count',
},
]
